import { Switch } from "shared/components/forms/Switch";
import { Stepper } from "../components/Stepper";
import { FormData, Views } from "../types";
import { Dispatch, SetStateAction } from "react";
import { DecisionAction } from "shared/types";
import { useSettingsController } from "views/settings-developers/controller";
import { useAuthContext } from "providers/Auth";

export const DecisionSettingsView = ({
  view,
  flow,
  formData,
  setFormData,
  address,
  disableAddApplicantsToPms
}: {
  formData: FormData;
  setFormData: Dispatch<SetStateAction<FormData>>;
  view: Views;
  flow: Views[];
  address: string;
  disableAddApplicantsToPms?: boolean;
}) => {
  const { isAppfolioEverySyncEnabled } = useSettingsController();
  const { type } = useAuthContext();

  return (
    <div className="flex flex-col h-full">
      <Stepper view={view} flow={flow} />

      <div className="p-6">
        {formData.decision === DecisionAction.Decline ||
        isAppfolioEverySyncEnabled ? null : (
          <Switch
            label={
              <>
                Disallow applying for unit
                <span className="block mt-2 text-sm text-content-400">
                  Acceptance of new applications will be paused for {address}
                </span>
              </>
            }
            checked={formData.unlistUnit}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, unlistUnit: value }))
            }
            wrapperClassName="mb-6 !gap-4"
          />
        )}

        <Switch
          label="Notify applicants about the decision via email"
          checked={formData.sendNotifications}
          onChange={(value) =>
            setFormData((prev) => ({ ...prev, sendNotifications: value }))
          }
          wrapperClassName="mb-6 !gap-4"
        />
        {disableAddApplicantsToPms || type.isManual ? null : (
          <Switch
            label="Add applicants to Property Management Software"
            checked={formData.addApplicantsToPMS}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, addApplicantsToPMS: value }))
            }
            wrapperClassName="mb-6 !gap-4"
          />
        )}
      </div>
    </div>
  );
};
